import { FC, useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Header } from "../../components/Header";
import { Menu } from "../../components/Menu";
import PixImg from "../../assets/images/pix.png";
import { useAppConfig } from "../../hooks/useAppConfig";
import { ConfigType } from "../../contexts/AppConfigContext";
import { Loading } from "../../components/Loading";
import api from "../../services/api";
import moment from "moment";

import styles from "./newChoosePayment.module.css";
import { usePluginspace } from "../../hooks/usePluginspace";
import { OrderAddress, ProductType } from "../../contexts/OrderContext";
import { PluginspaceResponseType } from "../../contexts/PluginspaceContext";
import Swal from "sweetalert2";
import { cpfCnpjNoMask, cpfMask, rtcToText } from "../../functions/mask";
import { Input } from "../../components/Input/Input";
import Switch from "../../components/Switch/Switch";
// icones
import visaLogo from "../../assets/images/visa.svg";
import ticketLogo from "../../assets/images/ticket.svg";
import masterCardLogo from "../../assets/images/masterCard.svg";
import redeLogo from "../../assets/images/rede.svg";
import aleloLogo from "../../assets/images/alelo.svg";
import americaExpressLogo from "../../assets/images/americanExpress.svg";
import eloLogo from "../../assets/images/elo.svg";
import hiperCardLogo from "../../assets/images/hipercard.svg";
import maestroLogo from "../../assets/images/maestro.svg";
import { CheckoutOrder } from "../../components/checkoutOrder/checkoutOrder";
import { SumaryOrder } from "../../components/sumaryOrder/sumaryOrder.module";
import { ButtonCheckout } from "../../components/buttonCheckout/ButtonCheckout";
import { CashbackInput } from "../../components/CashbackInput/cashbackInput";
import { CashbackEarnPreview } from "../../components/CashbackEarnPreview/cashbackEarnPreview";
import { calculatePriceFractionalToProduct } from "../../functions/price_functions";
import CardPaymentDiscount from "../../components/cardPaymentDiscount/cardPaymentDiscount";
import ModalSelectInstallment from "../../components/ModalSelectInstallment";
import { useToast } from "../../hooks/useToast";
import { useDiscount } from "../../hooks/useDiscount";
import { useCashbackRedeem } from "../../hooks/useCashbackRedeem";
import { useCashbackEarn } from "../../hooks/useCashbackEarn";
import { useSellerCart } from "../../hooks/useSellerCart";
import EmptyState from "../../components/EmptyStates/EmptyState";
import {
  CARD_OPERATORS,
  EXCLUDED_CARD_OPERATORS,
  FOOD_OPERATORS,
  IntegrationType,
  LocationResponseType,
  MethodsPaymentType,
  PluginconfigType,
  ProductCartType,
  WalletType,
} from "./newChoosePayment.type";
import { usePayment } from "../../contexts/paymentContext/paymentContext";
import useCart, {
  useCartTotal,
  useCartWithDiscountAndFreight,
} from "../../contexts/cartContext/cartContext";
import { useOrderMetaData } from "../../contexts/orderMetaDataContext/orderMetaDataContext";
import { useCustomer } from "../../contexts/customerContext/customerContext";
import { PaymentMethod } from "../../contexts/orderMetaDataContext/orderMetaData.type";
import { useSellerInfo } from "../../contexts/sellerInfoContext";
import { Customer } from "../../contexts/customerContext/customerType";
import { Discount } from "../../contexts/discountContext/discount.type";
import { calculateNinegridDiscount } from "./factory/paymentDiscountHelper";
import { Banknote, CreditCard } from "lucide-react";

const NewChoosePayment: FC<any> = () => {
  const navigate = useNavigate();
  const { pluginspace_id } = useParams();
  const { getToken, getThisPluginspace, registerAccess, pluginspace } =
    usePluginspace();
  const { setCpfVendorByLink, setUpdateCustomerCart } = useSellerInfo();
  const { updateCartWithProducts, addGuidCart, products } = useCart();

  const orderMetaData = useOrderMetaData();

  // Uso de Contexts
  const total = useCartWithDiscountAndFreight();
  const {
    setPaymentMethod,
    setPaymentIsAfter,
    setChangePayment,
    setGateWayId,
    clearPaymentMethod,
  } = usePayment();
  const { metadata } = useOrderMetaData();
  const { customer, setCustomer } = useCustomer();

  const { applyDiscount, removePaymentDiscount } = useDiscount();
  const [totvsVarejoAble, setTotvsVarejoAble] = useState(false);
  const [totvsChecked, setTotvsChecked] = useState(false);
  const cashbackAllowed = totvsChecked && !totvsVarejoAble;

  const {
    shouldShowCashback,
    availableBalance,
    redeemValue,
    setRedeemValue,
    hasCashback,
    appliedAmount,
    loading: loadingCashback,
    applyCashbackRedeem,
    clearCashbackRedeem,
  } = useCashbackRedeem({ enabled: cashbackAllowed });
  // const {
  //   shouldShowEarn,
  //   earnAmount,
  //   loading: loadingEarn,
  // } = useCashbackEarn();
  const sellerCartContext = useSellerCart();

  const [cpfNote, setCpfNote] = useState("");

  const [paymentMethods, setPaymentMethods] = useState<Array<PluginconfigType>>(
    [],
  );
  const [orderAddress, setOrderAddress] = useState<OrderAddress>();
  const { openToast } = useToast();

  const [openModalInstallment, setOpenModalInstallment] = useState(false);
  const [installments, setInstallments] = useState<number>(1);

  const { getAppConfig } = useAppConfig();
  const [config, setConfig] = useState<ConfigType | void>();
  const [loading, setLoading] = useState(true);
  const [gatewayIdSelected, setGatewayIdSelected] = useState(0);

  const [typePayment, setTypePayment] =
    useState<MethodsPaymentType>("delivery-payment");
  const [wallets, setWallets] = useState<WalletType[]>([]);

  const [momentType, setMomentType] = useState("before");
  const [paymentsAfter, setPaymentsAfter] = useState<IntegrationType[]>([]);
  const [selectedPaymentAfter, setSelectedPaymentAfter] =
    useState<IntegrationType | null>(null);
  const [typeAfter, setTypeAfter] = useState<
    "card" | "money" | "others" | "pix" | "food" | "debit-card"
  >("card");
  const [paymentMoney, setPaymentMoney] = useState("");

  const [havePaymentOnline, setHavePaymentOnline] = useState(false);
  const [isCounter, setIsCounter] = useState(false);

  const [needChanges, setNeedChanges] = useState(false);

  const [paymentDiscount, setPaymentDiscount] = useState<{
    typeDiscount: string;
    discountValue: string;
  } | null>(null);
  const [isApplyingPaymentDiscount, setIsApplyingPaymentDiscount] =
    useState(false);
  const [installmentPreviewTotal, setInstallmentPreviewTotal] = useState<
    number | null
  >(null);

  const [paymentsAfterAble, setPaymentsAfterAble] = useState({
    ableCredit: false,
    ableDebit: false,
    ableAlimentation: false,
    ablePix: false,
    ableMoney: false,
    ableOthers: false,
  });

  /*Variavel utilizada para saber se tem o plugin do motor de desconto */
  const [ninegridMotorAble, setNinegridMotorAble] = useState(false);

  const [nameTabeWithdrawal, setNameTabeWithdrawal] = useState<string | null>(
    null,
  );

  const [codePlanSelected, setCodePlanSelected] = useState<string>();

  useEffect(() => {
    registerAccess("order");
    getConfig();
    const isCounterStorage = localStorage.getItem("counter_number");
    setIsCounter(isCounterStorage ? true : false);
    clearPaymentMethod();
    resetDiscount();
  }, []);

  async function loadOrder() {
    if (window.location.search && window.location.search !== "") {
      const guidCart = window.location.search.split("=")[1];
      await getCart(guidCart);
    } else {
      setCpfNote(customer?.cpf ? cpfMask(customer.cpf) : "");

      if (metadata.deliveryAddress) {
        const address = metadata.deliveryAddress;
        const orderAddress: OrderAddress = {
          cep: address.cep,
          address: address.street,
          district: address.neighborhood,
          city: address.city,
          number: address.number,
          complement: address.complement ? address.complement : "",
          reference: "",
          telephone: "",
          ibge: "",
        };
        setOrderAddress(orderAddress);
      }
      await getPaymentMethods(0);
    }
  }

  async function getConfig() {
    localStorage.removeItem("qrcodePixPayment");
    setLoading(true);

    const findedConfig: ConfigType | void = await getAppConfig();

    setConfig(findedConfig);

    await loadOrder();

    if (findedConfig) {
      await getOperators(findedConfig.content.pdv.gatewayDeliveryId);
    }

    await verifyTotvs();
    await verifyNinegridProm();
    setLoading(false);
  }

  async function verifyTotvs() {
    try {
      const response = await api.post(
        `/api/pluginconfig/filter`,
        {
          plugintemplateId: 105,
        },
        {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        },
      );

      if (response.data.data.length > 0) {
        const configData = response.data.data[0];
        if (configData.content?.able === "1") {
          setTotvsVarejoAble(true);
        }
      }
    } catch (err) {
      console.log(err);
    } finally {
      setTotvsChecked(true);
    }
  }

  async function getOperators(gatewayPaymentAfter: number) {
    try {
      const pluginspace = await getThisPluginspace();
      if (pluginspace) {
        const resIntegration = await api.post(
          "api/orders/card-payment-get",
          {
            hash: pluginspace.hash,
          },
          {
            headers: {
              Authorization: `Bearer ${await getToken()}`,
            },
          },
        );
        if (
          resIntegration.data &&
          resIntegration.data.data &&
          resIntegration.data.data.data &&
          resIntegration.data.success
        ) {
          setPaymentsAfter(
            resIntegration.data.data.data.filter(
              (pymt: IntegrationType) =>
                pymt.plugintemplateId === 44 &&
                pymt.pluginconfigId === gatewayPaymentAfter,
            ),
          );
        } else {
          setPaymentsAfter([]);
        }
      } else {
        setPaymentsAfter([]);
      }
    } catch (error) {
      return;
    }
  }

  async function getPaymentMethods(locationId: number) {
    const locationIdToSend = locationId ? locationId : metadata.locationId;

    await api
      .post(
        `/api/pluginconfig/filter`,
        {
          plugintypeId: 14,
          locationId: locationIdToSend ? locationIdToSend : null,
        },
        {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        },
      )
      .then(async (response) => {
        const dataPayments = response.data.data.filter(
          (pluginconfigs: PluginconfigType) =>
            pluginconfigs.content.able === "1" ||
            pluginconfigs.content.ableCard === "1" ||
            pluginconfigs.content.ableDebit === "1" ||
            pluginconfigs.content.ablePix === "1" ||
            pluginconfigs.content.pix === "1" ||
            pluginconfigs.content.ableAlimentation === "1" ||
            pluginconfigs.content.ableOthers === "1" ||
            pluginconfigs.content.ableMoney === "1",
        );

        response.data.data.forEach((config: any) => {
          if (config.content.paymentWithdrawalTabCustom) {
            setNameTabeWithdrawal(config.content.paymentWithdrawalTabCustom);
            return;
          }
        });

        const configStore = await getAppConfig();
        if (configStore && configStore.content && configStore.content.pdv) {
          const paymentDelivery = response.data.data.find(
            (pluginconfig: PluginconfigType) =>
              pluginconfig.id === configStore.content.pdv.gatewayDeliveryId,
          );
          if (paymentDelivery && paymentDelivery.content) {
            if (paymentDelivery.content.pix)
              paymentDelivery.content.ablePix = paymentDelivery.content.pix;
            setPaymentsAfterAble({
              ableCredit:
                paymentDelivery.content.able &&
                paymentDelivery.content.able === "1"
                  ? true
                  : false,
              ableDebit:
                paymentDelivery.content.ableDebit &&
                paymentDelivery.content.ableDebit === "1"
                  ? true
                  : false,
              ableAlimentation:
                paymentDelivery.content.ableAlimentation &&
                paymentDelivery.content.ableAlimentation === "1"
                  ? true
                  : false,
              ablePix:
                paymentDelivery.content.ablePix &&
                paymentDelivery.content.ablePix === "1"
                  ? true
                  : false,
              ableMoney:
                paymentDelivery.content.ableMoney &&
                paymentDelivery.content.ableMoney === "1"
                  ? true
                  : false,
              ableOthers:
                paymentDelivery.content.ableOthers &&
                paymentDelivery.content.ableOthers === "1"
                  ? true
                  : false,
            });
          }
          const paymentsOnline = dataPayments.filter(
            (pluginconfigs: PluginconfigType) =>
              pluginconfigs.plugintemplateId.id !== 44 &&
              (pluginconfigs.id === configStore.content.pdv.gatewayId ||
                pluginconfigs.id === configStore.content.pdv.gatewayPixId),
          );

          setHavePaymentOnline(paymentsOnline && paymentsOnline.length > 0);
        }
        setPaymentMethods(dataPayments);
        const paymentHub = dataPayments.find(
          (pluginconfigs: PluginconfigType) =>
            pluginconfigs.plugintemplateId.id === 25,
        );
        const pluginspaceData: void | PluginspaceResponseType =
          await getThisPluginspace();
        if (paymentHub) {
          await api
            .post(
              `/api/totvshub/listWalletPay`,
              {
                pluginspaceId: pluginspaceData ? pluginspaceData.id : 0,
                gatewayId: paymentHub.id,
              },
              {
                headers: {
                  Authorization: `Bearer ${await getToken()}`,
                },
              },
            )
            .then((responseWallet) => {
              const walletsResponse = responseWallet.data.paymentMethods;
              setWallets(walletsResponse);
            })
            .catch((err) => {
              console.log(err);
            });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function prepareAfterPayment() {
    if (momentType === "after") {
      if (!selectedPaymentAfter) {
        Swal.fire({
          icon: "warning",
          title: "Atenção!",
          text: "Selecione um meio de pagamento.",
        });
        return;
      }
      const codePlan =
        selectedPaymentAfter.paymentPlans && codePlanSelected
          ? codePlanSelected
          : (selectedPaymentAfter.paymentPlans?.[0]?.codePlan ?? 0);

      const paymentMethod: PaymentMethod = {
        codePay: selectedPaymentAfter.codePay,
        codePlan: parseInt(codePlan.toString()),
        nameGateway: selectedPaymentAfter.nameGateway,
        nameBrand: selectedPaymentAfter.brand,
        typePayment: typeAfter,
        paymentItemData: selectedPaymentAfter,
        installments: installments,
        isAfter: true,
        method: typePayment,
      };
      setPaymentMethod(paymentMethod);
      if (
        selectedPaymentAfter.cardOperator === 100 &&
        (!paymentMoney ||
          parseFloat(total.toFixed(2)) > parseFloat(paymentMoney))
      ) {
        Swal.fire({
          icon: "warning",
          title: "Atenção!",
          text: "O pagamento em dinheiro deve ser maior ou igual ao valor da compra.",
        });
        return false;
      }
      setChangePayment(
        parseFloat((parseFloat(paymentMoney) - total).toFixed(2)),
      );
    } else {
      setChangePayment(0);
    }

    return true;
  }

  function navigateByPaymentType(payment: MethodsPaymentType) {
    setLoading(false);

    if (payment.includes("card")) {
      navigate(`/${pluginspace_id}/card`);
      return;
    }

    if (
      payment.includes("pix") ||
      payment.includes("shipay") ||
      payment.includes("wallet") ||
      payment.includes("delivery-payment")
    ) {
      if (pluginspace.type !== "food") {
        navigate(`/${pluginspace_id}/new-order-finalize`);
      } else {
        navigate(`/${pluginspace_id}/order-finalize`);
      }
    }
  }

  function getSelectedPaymentDiscountConfig(): {
    apply: boolean;
    type: "monetary" | "percentage";
    value: string;
  } {
    if (!ninegridMotorAble) {
      return {
        apply: false,
        type: "percentage",
        value: "0",
      };
    }

    if (momentType === "after") {
      return {
        apply: Boolean(selectedPaymentAfter?.ableDiscount),
        type: selectedPaymentAfter?.typeDiscount ?? "percentage",
        value: selectedPaymentAfter?.discountValue ?? "0",
      };
    }

    const selectedPayment = paymentMethods.find(
      (payment) => payment.id === gatewayIdSelected,
    );

    if (!selectedPayment) {
      return {
        apply: false,
        type: "percentage",
        value: "0",
      };
    }

    if (typePayment.includes("pix") || typePayment.includes("wallet")) {
      return {
        apply: Boolean(selectedPayment.content?.["discountPixAble"]),
        type: selectedPayment.content?.["discountPixType"] ?? "percentage",
        value: selectedPayment.content?.["discountPixValue"] ?? "0",
      };
    }

    return {
      apply: Boolean(selectedPayment.content?.["discountCardAble"]),
      type: selectedPayment.content?.["discountCardType"] ?? "percentage",
      value: selectedPayment.content?.["discountCardValue"] ?? "0",
    };
  }

  async function syncSelectedPaymentDiscount() {
    const discountConfig = getSelectedPaymentDiscountConfig();
    const sameDiscountApplied =
      discountConfig.apply &&
      paymentDiscount?.typeDiscount === discountConfig.type &&
      paymentDiscount?.discountValue === discountConfig.value;

    setIsApplyingPaymentDiscount(true);

    try {
      await applyDiscountNinegrid(
        discountConfig.apply,
        discountConfig.type,
        discountConfig.value,
        sameDiscountApplied,
      );

      const discountValue = parseFloat(discountConfig.value || "0");
      const previewTotal =
        discountConfig.apply &&
        discountConfig.type === "monetary" &&
        !Number.isNaN(discountValue)
          ? Math.max(total - discountValue, 0)
          : total;

      setInstallmentPreviewTotal(previewTotal);
      return previewTotal;
    } finally {
      setIsApplyingPaymentDiscount(false);
    }
  }

  async function choosePayment() {
    if (!prepareAfterPayment()) {
      return;
    }

    if (cpfNote === "" || !cpfNote || cpfNote.includes("_")) {
      Swal.fire({
        icon: "warning",
        title: "Atenção!",
        text: "É necessário informar um CPF válido na nota",
      });
      setLoading(false);
      return;
    }

    if (!gatewayIdSelected) {
      Swal.fire({
        icon: "warning",
        title: "Atenção!",
        text: "É necessário informar um meio de pagamento",
      });
      setLoading(false);
      return;
    }

    setPaymentIsAfter(momentType === "after");

    await syncSelectedPaymentDiscount();
    setLoading(true);

    navigateByPaymentType(typePayment);
  }

  async function validateCart(timeCart: string): Promise<{
    valid: boolean;
    msg: string;
  }> {
    try {
      let valid = false;
      const configLocal = await getAppConfig();
      const pg = await getThisPluginspace();

      const gtmValue =
        !pg || !pg?.gmt?.split(":")[0] ? -3 : parseInt(pg.gmt.split(":")[0]);

      const carrinhoDataCriacao = moment
        .utc(timeCart)
        .utcOffset(gtmValue)
        .seconds(0);
      const now = moment().utcOffset(gtmValue).seconds(0); // Data e hora atuais ajustadas para o GMT

      const hour = configLocal
        ? configLocal.content.pdv.sellerCartExpirationTime.split(":")[0]
        : "2";
      const minute = configLocal
        ? configLocal?.content.pdv.sellerCartExpirationTime.split(":")[1]
        : "0";

      const validTimeCart = carrinhoDataCriacao
        .clone()
        .add(parseInt(hour), "hours")
        .add(parseInt(minute), "minutes");

      valid = validTimeCart.isAfter(now) || validTimeCart.isSame(now, "second");
      const timeDifference = now.diff(validTimeCart, "minutes");
      const hours = Math.floor(timeDifference / 60);
      const minutes = timeDifference % 60;

      let msg = "";

      if (hours && minutes) {
        msg += `${hours} hora(s) e ${minutes} minuto(s) `;
      } else if (minutes) {
        msg += `${minutes} minuto(s) `;
      }

      return {
        valid: valid,
        msg: msg,
      };
    } catch (er) {
      return {
        valid: false,
        msg: ``,
      };
    }
  }

  async function getCart(guid: string) {
    await api
      .get(`/api/customerCart/guid/${guid}`, {
        headers: {
          Authorization: `Bearer ${await getToken()}`,
        },
      })
      .then(async (response) => {
        const order = response.data.data[0];

        const isValid = await validateCart(order.created);
        if (!isValid || !isValid.valid) {
          let text =
            "O carrinho do vendedor está expirado. Favor entrar em contato com o seu vendedor";

          if (isValid && isValid.msg) {
            text = `O carrinho do vendedor expirou por ${isValid.msg}. Favor entrar em contato com o seu vendedor.`;
          }

          Swal.fire({
            icon: "warning",
            titleText: "Carrinho expirado",
            text: text,
          }).then(() => navigate(`/${pluginspace_id}/category`));
          return;
        }

        if (order.status != "open") {
          Swal.fire({
            icon: "warning",
            titleText: "Carrinho já utilizado",
            text: "O carrinho do vendedor já foi utilizado. Favor entrar em contato com o seu vendedor",
          }).then(() => navigate(`/${pluginspace_id}/category`));
          return;
        }

        if (order && order.cpfSeller) {
          setCpfVendorByLink(order.cpfSeller);
        }
        setCustomer({
          id: "0",
          email: "",
          name: order.customerName,
          phone: order.phoneCustomer,
          cpf: order.cpfCustomer,
        });

        addGuidCart(guid);
        const customerCart = response.data.data[0];
        const address = customerCart.jsonCart.address;
        setOrderAddress(address);

        orderMetaData.setOrderType("withdraw");
        orderMetaData.setFreightCost(customerCart.jsonCart.freight);

        setCpfNote(cpfMask(customerCart.cpfCustomer));
        orderMetaData.setDeliveryAddress(address);

        const productsCart = customerCart.jsonCart.products.map(
          (product: ProductCartType) => {
            const variationFormated: any = {};
            product.variation.map((variation: any) => {
              variationFormated[variation.grid] = variation.value
                ? variation.value
                : variation.valor;
            });
            const newProduct: ProductType = {
              id: product.id,
              image: product.img,
              code: product.code,
              locationId: customerCart.locationId,
              name: product.name,
              promotionalPrice: product.promotional_price,
              quantity: product.quantity,
              sku: product.sku,
              stock: product.sku_info[0].inventory,
              unitPrice: product.unitPrice,
              variation: variationFormated,
              pluginspaceHash: pluginspace_id ? pluginspace_id : "",
              outStock: false,
              measures: product.sku_info[0].measures
                ? product.sku_info[0].measures
                : null,
            };
            return newProduct;
          },
        );

        updateCartWithProducts(productsCart);

        const totalValue = await saveTotalandDiscount(productsCart);
        await findCustomer(customerCart.cpfCustomer);

        const locationIdSend = await findLocationId(customerCart.jsonCart.type);
        await getPaymentMethods(locationIdSend ? locationIdSend : 0);
        setUpdateCustomerCart(true);

        // Salva os dados completos do carrinho do vendedor no contexto
        // Os dados são automaticamente criptografados e salvos no localStorage
        sellerCartContext.setSellerCartData(customerCart);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function saveTotalandDiscount(products: any[]) {
    let newTotal = 0;
    let newTotalWithoutDiscount = 0;
    products.map((prod) => {
      if (
        prod.unitPrice === prod.promotionalPrice ||
        prod.promotionalPrice === 0
      ) {
        newTotal += prod.quantity * prod.unitPrice;
      } else {
        newTotal += prod.quantity * prod.promotionalPrice;
      }
      newTotalWithoutDiscount += prod.quantity * prod.unitPrice;
      if (prod.additionals) {
        prod.additionals.map((additional: any) => {
          newTotalWithoutDiscount +=
            prod.quantity * (additional.quantity * additional.price);
          newTotal += prod.quantity * (additional.quantity * additional.price);
        });
      }
      if (prod.fractions && prod.fractions.length > 0) {
        let priceFractional = calculatePriceFractionalToProduct(prod);

        newTotalWithoutDiscount += prod.quantity * priceFractional;
        newTotal += prod.quantity * priceFractional;
      }
      return prod;
    });

    return newTotal;
  }

  async function findCustomer(documento: string) {
    setLoading(true);
    const cpfWithouthMask = cpfCnpjNoMask(documento);
    await api
      .post(
        `/api/customer/filter`,
        {
          cpf: cpfWithouthMask,
        },
        {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        },
      )
      .then(async (response) => {
        if (response.data.data.length > 0) {
          const customerRes = response.data.data[0];

          const telephone = customerRes.customerPhones[0]
            ? customerRes.customerPhones[0].numberPhone
            : "";
          const customerToSet: Customer = {
            id: response.data.dados.id
              ? response.data.dados.id
              : response.data.dados.dados.id,
            name: customerRes.name,
            email: customerRes.email,
            cpf: customerRes.cpf,
            phone: telephone,
            birthdate: customerRes.birthDate,
            wppNotification: customerRes.optinWhatsapp,
            validateRegister: true,
            acceptTermDate: response.data.dados.lgpdDataAceiteCarta
              ? response.data.dados.lgpdDataAceiteCarta
              : response.data.dados.dados.lgpdDataAceiteCarta,
            gender: customerRes.gender,
            customerWinthor: response.data.dados.customerId
              ? response.data.dados.customerId
              : undefined,
          };
          setCustomer(customerToSet);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  async function findLocationId(type: string) {
    return await api
      .get(`/api/location`, {
        headers: {
          Authorization: `Bearer ${await getToken()}`,
        },
      })
      .then(async (response) => {
        const location = response.data.data.find(
          (location: LocationResponseType) => location.code == type,
        );
        orderMetaData.setLocationId(location ? location.id : 0);
        return location ? location.id : 0;
      })
      .catch((err) => {
        console.log(err);
        Swal.fire({
          icon: "error",
          title: "Erro",
          text: "Erro ao encontrar loja",
        });
        return 0;
      });
  }

  async function changePayment(payment: MethodsPaymentType, paymentId: number) {
    setInstallmentPreviewTotal(null);
    setGateWayId(paymentId);
    setGatewayIdSelected(paymentId);
    setTypePayment(payment);
  }

  useEffect(() => {
    setInstallmentPreviewTotal(null);
  }, [selectedPaymentAfter, typeAfter]);

  function cardIcon(cardBrand: string) {
    switch (cardBrand) {
      case "visa":
        return (
          <img
            src={visaLogo}
            style={{
              width: "32px",
              height: "auto",
            }}
          />
        );

      case "mastercard":
        return (
          <img
            src={masterCardLogo}
            style={{
              width: "32px",
              height: "auto",
            }}
          />
        );
      case "americanexpress":
        return (
          <img
            src={americaExpressLogo}
            style={{
              width: "32px",
              height: "auto",
            }}
          />
        );
      case "elo":
        return (
          <img
            src={eloLogo}
            style={{
              width: "32px",
              height: "auto",
            }}
          />
        );
      case "hipercard":
        return (
          <img
            src={hiperCardLogo}
            style={{
              width: "32px",
              height: "auto",
            }}
          />
        );
      case "maestro":
        return (
          <img
            src={maestroLogo}
            style={{
              width: "32px",
              height: "auto",
            }}
          />
        );
      case "rede":
        return (
          <img
            src={redeLogo}
            style={{
              width: "32px",
              height: "auto",
            }}
          />
        );
      case "ticket":
        return (
          <img
            src={ticketLogo}
            style={{
              width: "32px",
              height: "auto",
            }}
          />
        );
      case "alelo":
        return (
          <img
            src={aleloLogo}
            style={{
              width: "32px",
              height: "auto",
            }}
          />
        );
      case "others":
        return (
          <>
            <svg
              width="16"
              height="16"
              viewBox="0 0 50 50"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M49.4863 20.9105C49.4863 19.0549 48.4396 17.4267 46.9118 16.5915C47.0757 16.1104 47.1708 15.6029 47.1708 15.0743C47.1708 13.832 46.6898 12.6689 45.8175 11.7967L35.3768 1.35597C33.5688 -0.45199 30.6296 -0.45199 28.8216 1.35597L21.0241 9.15346C11.5297 9.22218 2.51634 10.2425 0.481065 18.0241C0.142734 18.8329 0 19.832 0 20.9052V44.599C0 47.3004 2.20973 49.5101 4.91109 49.5101H44.5752C47.2766 49.5101 49.4863 47.3004 49.4863 44.599V37.6632H31.1582C28.4569 37.6632 26.2471 35.4535 26.2471 32.7521C26.2471 30.0507 28.4569 27.841 31.1582 27.841H49.4863V20.9052V20.9105ZM17.8258 12.3465L14.1782 15.9941H5.00096C7.09439 13.7421 11.1174 12.6478 17.8258 12.3465ZM18.6347 15.9941L31.0419 3.58685C31.6181 3.01062 32.5644 3.00534 33.1406 3.58685L43.5813 14.0275C43.8615 14.3077 44.0148 14.6778 44.0148 15.0743C44.0148 15.4179 43.8985 15.7351 43.6924 15.9941H18.64H18.6347Z"
                fill="#1B1B1B"
              />
              <path
                d="M27.7803 32.8365C27.7803 34.8348 29.4032 36.4578 31.4015 36.4578C33.3998 36.4578 35.0227 34.8348 35.0227 32.8365C35.0227 30.8383 33.3998 29.2153 31.4015 29.2153C29.4032 29.2153 27.7803 30.8383 27.7803 32.8365Z"
                fill="#1B1B1B"
              />
            </svg>
          </>
        );
      default:
        return (
          <>
            <div
              style={{
                width: "32px",
                height: "auto",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <i
                className="fa fa-credit-card"
                style={{
                  color: "#3C9EE5",
                }}
              />
            </div>
          </>
        );
    }
  }

  function chooseMethodPaymentDefault() {
    if (havePaymentOnline) {
      setMomentType("before");
    } else if (paymentsAfter && paymentsAfter.length > 0) {
      setMomentType("after");
    }
  }

  /* Funcoes utilizadas para aplicar desconto no meio do pagamento selecionado */
  //verificação do motor de promoção ninegrid

  async function verifyNinegridProm() {
    await api
      .post(
        `/api/pluginconfig/filter`,
        {
          plugintemplateId: 107,
        },
        {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        },
      )
      .then(async (response) => {
        if (response.data.data.length > 0) {
          const configData: PluginconfigType = response.data.data[0];
          if (configData.content.able === "1") {
            setNinegridMotorAble(true);
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  async function applyDiscountNinegrid(
    apply: boolean,
    type: "monetary" | "percentage",
    value: string,
    applyed: boolean,
  ) {
    try {
      if (!ninegridMotorAble || !apply || !value || parseFloat(value) <= 0) {
        resetDiscount();
        return total;
      }
      if (applyed) return total;

      const productsToDiscount = resetDiscount();

      if (apply) {
        const couponData: Discount = {
          type: "payment",
          value: parseFloat(value),
          appliedAt: new Date(),
        };

        const discountData = {
          nameCoupom: "Pagamento",
          valueDiscount: type === "monetary" ? value : "0",
          percentageDiscount: type === "percentage" ? value : "0",
        };
        const token = await getToken();

        if (!token) {
          resetDiscount();
          return total;
        }

        //fazer envio de requesto para o motor de desconto ninegrid
        const { success, discountedProducts, totalDiscount, errorMsg } =
          await calculateNinegridDiscount(
            discountData,
            productsToDiscount,
            token,
          );

        if (!success) {
          console.error("Error applying ninegrid discount:", errorMsg);
          resetDiscount();
          return total;
        }

        // Atualizar os produtos com os descontos aplicados
        updateCartWithProducts(discountedProducts);

        setPaymentDiscount({ typeDiscount: type, discountValue: value });
        applyDiscount(couponData);
        return Math.max(total - totalDiscount, 0);
      } else {
        // Remove the discount
        resetDiscount();
        return total;
      }
    } catch (error) {
      console.error("Error applying discount:", error);
      resetDiscount();
      return total;
    }
  }

  // Reset discount to its original state
  function resetDiscount() {
    removePaymentDiscount("payment");
    // voltar para os valores originais do carrinho (preserva cupom e cashback)
    const newProducts = products.map((prod) => {
      const originalDiscountPrice =
        prod.cashbackPrice ??
        prod.cupomDiscount ??
        prod.oldDiscountPrice ??
        prod.promotionalPrice ??
        prod.unitPrice ??
        0;
      return { ...prod, promotionalPrice: originalDiscountPrice };
    });

    updateCartWithProducts(newProducts);
    setPaymentDiscount(null);

    return newProducts;
  }

  useEffect(() => {
    chooseMethodPaymentDefault();
  }, [havePaymentOnline, paymentsAfter]);
  const hasPaymentsForTypeOfFreight = useMemo(() => {
    return !(
      (!havePaymentOnline && (!paymentsAfter || paymentsAfter.length === 0)) ||
      (orderAddress?.frenet && !havePaymentOnline)
    );
  }, [orderAddress, paymentsAfterAble]);

  const {
    creditPayments,
    debitPayments,
    foodPayments,
    pixPayments,
    moneyPayment,
    othersPayments,
  } = useMemo(() => {
    const creditPayments = paymentsAfter.filter(
      (p) =>
        p.typePay === "Credit" && !EXCLUDED_CARD_OPERATORS.has(p.cardOperator),
    );

    const debitPayments = paymentsAfter.filter(
      (p) =>
        p.typePay === "Debit" && !EXCLUDED_CARD_OPERATORS.has(p.cardOperator),
    );

    const foodPayments = paymentsAfter.filter(
      (p) => p.typePay === "Credit" && FOOD_OPERATORS.has(p.cardOperator),
    );

    const pixPayments = paymentsAfter.filter(
      (p) => p.cardOperator === CARD_OPERATORS.PIX,
    );

    const moneyPayment = paymentsAfter.find(
      (p) => p.cardOperator === CARD_OPERATORS.MONEY,
    );

    const othersPayments = paymentsAfter.filter(
      (p) =>
        p.typePay === "Others" && !EXCLUDED_CARD_OPERATORS.has(p.cardOperator),
    );

    return {
      creditPayments,
      debitPayments,
      foodPayments,
      pixPayments,
      moneyPayment,
      othersPayments,
    };
  }, [paymentsAfter]);

  const isAbleCard = (content: any) =>
    Object.entries(content ?? {}).some(
      ([key, value]) => key.replace(/\W/gi, "") === "ableCard" && value === "1",
    );

  const renderCardOption = (
    payment: PluginconfigType,
    typeValue: MethodsPaymentType,
  ) => (
    <div
      className={
        gatewayIdSelected === payment.id && typePayment === typeValue
          ? styles.type_method_selected
          : styles.type_method
      }
      onClick={() => {
        changePayment(typeValue, payment.id);
      }}
    >
      <CreditCard size={16} color="#3C9EE5" />
      <p>Cartão de crédito</p>
      {ninegridMotorAble && payment.content?.["discountCardAble"] && (
        <CardPaymentDiscount
          discountType={payment.content["discountCardType"] ?? "percentage"}
          discountValue={payment.content["discountCardValue"]}
        />
      )}
    </div>
  );

  const renderPixOption = (
    payment: PluginconfigType,
    typeValue: MethodsPaymentType,
  ) => (
    <div
      className={
        gatewayIdSelected === payment.id && typePayment === typeValue
          ? styles.type_method_selected
          : styles.type_method
      }
      onClick={() => {
        changePayment(typeValue, payment.id);
      }}
    >
      <img className="w-4 h-4" src={PixImg} alt="Pix" />
      <p>Pix</p>
      {ninegridMotorAble && payment.content?.["discountPixAble"] && (
        <CardPaymentDiscount
          discountType={payment.content["discountPixType"] ?? "percentage"}
          discountValue={payment.content["discountPixValue"]}
        />
      )}
    </div>
  );

  const renderWalletOption = (
    payment: PluginconfigType,
    wallet: WalletType,
  ) => (
    <div
      className={
        gatewayIdSelected === payment.id &&
        typePayment === `${wallet.code}-wallet`
          ? styles.type_method_selected
          : styles.type_method
      }
      onClick={() => {
        changePayment(`${wallet.code}-wallet`, payment.id);
      }}
    >
      <img className="w-4 h-4" src={wallet.logo} alt={wallet.name} />
      <p>{wallet.name}</p>
      {ninegridMotorAble && payment.content?.["discountPixAble"] && (
        <CardPaymentDiscount
          discountType={payment.content["discountPixType"] ?? "percentage"}
          discountValue={payment.content["discountPixValue"]}
        />
      )}
    </div>
  );

  return (
    <div className={styles.order_info}>
      <div className={styles.content_order_info}>
        <Header
          background={
            config?.webappcolor.backgroundheader
              ? config?.webappcolor.backgroundheader
              : "#F5F5F5"
          }
          colorIcon={
            config?.webappcolor.iconsheader
              ? config.webappcolor.iconsheader
              : "#636363"
          }
          logo={config?.icon ? config.icon : ""}
          backgroundCart={
            config?.webappcolor.backgroundcart
              ? config.webappcolor.backgroundcart
              : "#FFBA49"
          }
          fontCart={
            config?.webappcolor.fontcart ? config.webappcolor.fontcart : "#000"
          }
          noSales={
            config &&
            config?.content &&
            config?.content.pdv &&
            config?.content.pdv.noSales
              ? config.content.pdv.noSales
              : false
          }
        />
        {loading ? (
          <div style={{ width: "100%", height: "calc(100vh)" }}>
            <Loading
              type="spinningBubbles"
              color="#FFF"
              width={64}
              height={64}
            />
          </div>
        ) : (
          <div className={styles.order_info_body}>
            <div className={styles.order_info_body_content}>
              <CheckoutOrder position={3} name={"Forma de pagamento"} />
              <SumaryOrder page="pagamento" />
              {/* {shouldShowEarn && (
                <CashbackEarnPreview
                  amount={earnAmount}
                  loading={loadingEarn}
                />
              )} */}
              {cashbackAllowed && shouldShowCashback && (
                <CashbackInput
                  redeemValue={redeemValue}
                  setRedeemValue={setRedeemValue}
                  availableBalance={availableBalance}
                  hasCashback={hasCashback}
                  appliedAmount={appliedAmount}
                  loading={loadingCashback}
                  onApply={applyCashbackRedeem}
                  onRemove={() => clearCashbackRedeem()}
                />
              )}

              <div className={styles.payment_tab}>
                {/* Mensagem caso não haja nenhum método de pagamento disponível */}
                {hasPaymentsForTypeOfFreight ? (
                  <div className={styles.no_payment_methods_empty}>
                    <EmptyState
                      type="delivery"
                      textButton=""
                      colorIcon={
                        config?.webappcolor.iconsheader
                          ? config.webappcolor.iconsheader
                          : "#CEA127"
                      }
                      noShowBackground
                    />
                  </div>
                ) : (
                  <>
                    <div className={styles.payment_tab_options}>
                      {havePaymentOnline && (
                        <div
                          className={styles.payment_tab_option}
                          onClick={() => {
                            setMomentType("before");
                          }}
                          style={{
                            opacity: momentType !== "before" ? "50%" : "100%",
                          }}
                        >
                          <span>Pague antecipado</span>
                        </div>
                      )}

                      {paymentsAfter &&
                        paymentsAfter.length > 0 &&
                        !isCounter &&
                        !orderAddress?.frenet &&
                        paymentMethods.map((payment) => {
                          if (
                            payment.id ===
                              config?.content.pdv.gatewayDeliveryId &&
                            payment.plugintemplateId.id === 44
                          ) {
                            return (
                              <div
                                className={styles.payment_tab_option}
                                onClick={() => {
                                  changePayment("delivery-payment", payment.id);
                                  setMomentType("after");
                                }}
                                style={{
                                  opacity:
                                    momentType === "before" ? "50%" : "100%",
                                }}
                              >
                                {(nameTabeWithdrawal && (
                                  <span>{nameTabeWithdrawal}</span>
                                )) || <span>Pague ao receber</span>}
                              </div>
                            );
                          }
                        })}
                    </div>

                    {/*	Pagamentos Antecipados*/}

                    {momentType === "before" && (
                      <div className={styles.payment_tab_moment_type}>
                        {paymentMethods.map((payment) => {
                          const isGateway =
                            payment.id === config?.content.pdv.gatewayId;
                          const isPixGateway =
                            payment.id === config?.content.pdv.gatewayPixId;

                          if (!isGateway && !isPixGateway) return null;

                          switch (payment.plugintemplateId.id) {
                            case 25: {
                              const ableCard = isAbleCard(payment.content);

                              if (isPixGateway && wallets?.length) {
                                return (
                                  <>
                                    {ableCard &&
                                      renderCardOption(payment, "totvs-card")}
                                    {wallets.map((wallet) =>
                                      renderWalletOption(payment, wallet),
                                    )}
                                  </>
                                );
                              }

                              return ableCard
                                ? renderCardOption(payment, "totvs-card")
                                : null;
                            }

                            case 12:
                              return renderCardOption(payment, "esitef-card");

                            case 20:
                              return renderCardOption(payment, "cielo-card");

                            case 10:
                              if (isPixGateway && payment.content.pix === "1") {
                                return (
                                  <>
                                    {renderCardOption(
                                      payment,
                                      "pagseguro-card",
                                    )}
                                    {renderPixOption(payment, "pagseguro-pix")}
                                  </>
                                );
                              }
                              return renderCardOption(
                                payment,
                                "pagseguro-card",
                              );

                            case 47:
                              return renderCardOption(payment, "rede-card");

                            default:
                              return null;
                          }
                        })}
                      </div>
                    )}
                    {momentType === "after" && (
                      <div className={styles.payment_tab_moment_type}>
                        {creditPayments.length > 0 &&
                          paymentsAfterAble.ableCredit && (
                            <>
                              <div className={styles.payment_card_option}>
                                <span className="font-bold text-text-dark">
                                  Cartão de crédito
                                </span>
                              </div>
                              {creditPayments.map((payment) => (
                                <div
                                  className={
                                    payment.id === selectedPaymentAfter?.id
                                      ? styles.type_method_selected
                                      : styles.type_method
                                  }
                                  onClick={() => {
                                    changePayment(
                                      "delivery-payment",
                                      payment.pluginconfigId,
                                    );
                                    setTypeAfter("card");

                                    setSelectedPaymentAfter(payment);
                                  }}
                                >
                                  {cardIcon(payment.brand.toLowerCase())}
                                  <p>{payment.brand}</p>
                                  {ninegridMotorAble &&
                                    payment.ableDiscount && (
                                      <CardPaymentDiscount
                                        discountType={
                                          payment.typeDiscount ?? "percentage"
                                        }
                                        discountValue={payment.discountValue}
                                      />
                                    )}
                                </div>
                              ))}
                            </>
                          )}

                        {debitPayments.length > 0 &&
                          paymentsAfterAble.ableDebit && (
                            <>
                              <div className={styles.payment_card_option}>
                                <span className="font-bold text-text-dark">
                                  Cartão de débito
                                </span>
                              </div>
                              {debitPayments.map((payment) => (
                                <div
                                  className={
                                    payment.id === selectedPaymentAfter?.id
                                      ? styles.type_method_selected
                                      : styles.type_method
                                  }
                                  onClick={() => {
                                    changePayment(
                                      "delivery-payment",
                                      payment.pluginconfigId,
                                    );
                                    setTypeAfter("debit-card");
                                    setSelectedPaymentAfter(payment);
                                  }}
                                >
                                  {cardIcon(payment.brand.toLowerCase())}
                                  <p>{payment.brand}</p>
                                  {ninegridMotorAble &&
                                    payment.ableDiscount && (
                                      <CardPaymentDiscount
                                        discountType={
                                          payment.typeDiscount ?? "percentage"
                                        }
                                        discountValue={payment.discountValue}
                                      />
                                    )}
                                </div>
                              ))}
                            </>
                          )}

                        {foodPayments.length > 0 &&
                          paymentsAfterAble.ableAlimentation && (
                            <>
                              <div className={styles.payment_card_option}>
                                <span className="font-bold text-text-dark">
                                  Alimentação
                                </span>
                              </div>
                              {foodPayments.map((payment) => (
                                <div
                                  className={
                                    payment.id === selectedPaymentAfter?.id
                                      ? styles.type_method_selected
                                      : styles.type_method
                                  }
                                  onClick={() => {
                                    changePayment(
                                      "delivery-payment",
                                      payment.pluginconfigId,
                                    );
                                    setTypeAfter("food");
                                    setSelectedPaymentAfter(payment);
                                  }}
                                >
                                  {cardIcon(payment.brand.toLowerCase())}
                                  <p>{payment.brand}</p>
                                  {ninegridMotorAble &&
                                    payment.ableDiscount && (
                                      <CardPaymentDiscount
                                        discountType={
                                          payment.typeDiscount ?? "percentage"
                                        }
                                        discountValue={payment.discountValue}
                                      />
                                    )}
                                </div>
                              ))}
                            </>
                          )}

                        {paymentsAfterAble.ablePix &&
                          pixPayments.length > 0 && (
                            <>
                              <div className={styles.payment_card_option}>
                                <span className="font-bold text-text-dark">
                                  Pix
                                </span>
                              </div>
                              {pixPayments.map((payment) => (
                                <div
                                  className={
                                    typeAfter === "pix"
                                      ? styles.type_method_selected
                                      : styles.type_method
                                  }
                                  onClick={() => {
                                    changePayment(
                                      "delivery-payment",
                                      payment.pluginconfigId,
                                    );
                                    setTypeAfter("pix");
                                    setSelectedPaymentAfter(payment);
                                  }}
                                >
                                  <img
                                    className="w-4 h-4"
                                    src={PixImg}
                                    alt="Pix"
                                  />
                                  <p>Pix</p>
                                  {ninegridMotorAble &&
                                    payment.ableDiscount && (
                                      <CardPaymentDiscount
                                        discountType={
                                          payment.typeDiscount ?? "percentage"
                                        }
                                        discountValue={payment.discountValue}
                                      />
                                    )}
                                </div>
                              ))}
                            </>
                          )}

                        {paymentsAfterAble.ableMoney && moneyPayment && (
                          <>
                            <div className={styles.payment_card_option}>
                              <span className="font-bold text-text-dark">
                                Dinheiro
                              </span>
                            </div>
                            <div
                              className={
                                selectedPaymentAfter &&
                                selectedPaymentAfter.id === moneyPayment.id
                                  ? styles.type_method_selected
                                  : styles.type_method
                              }
                              onClick={() => {
                                setTypeAfter("money");
                                changePayment(
                                  "delivery-payment",
                                  moneyPayment.pluginconfigId,
                                );
                                setSelectedPaymentAfter(moneyPayment);
                                setPaymentMoney(total.toFixed(2));
                              }}
                            >
                              <Banknote size={16} color="#E19C15" />
                              <p>Pagamento em dinheiro</p>
                              {ninegridMotorAble &&
                                moneyPayment.ableDiscount && (
                                  <CardPaymentDiscount
                                    discountType={
                                      moneyPayment.typeDiscount ?? "percentage"
                                    }
                                    discountValue={moneyPayment.discountValue}
                                  />
                                )}
                            </div>

                            {typeAfter === "money" && (
                              <div>
                                <p className=" text-[10px]">
                                  Precisa de troco?
                                </p>
                                <Switch
                                  change={(value: boolean) => {
                                    setNeedChanges(value);

                                    if (value) {
                                      setPaymentMoney("0");
                                    } else {
                                      setPaymentMoney(total.toFixed(2));
                                    }
                                  }}
                                  value={needChanges}
                                  label="Precisa de troco?"
                                />
                              </div>
                            )}

                            {needChanges && (
                              <div className={styles.inputs_change}>
                                <div
                                  className={styles.input}
                                  style={{ width: "60%" }}
                                >
                                  <label>Troco para</label>
                                  <Input
                                    inputAttr={{
                                      type: "money",
                                    }}
                                    label={""}
                                    textCenter={true}
                                    placeholder="Pagamento"
                                    value={paymentMoney}
                                    locale="pt-BR"
                                    currency="BRL"
                                    change={(value: string) =>
                                      setPaymentMoney(value)
                                    }
                                    backgroundColor={"#dbdbdb"}
                                  />
                                </div>
                                <div
                                  className={`${styles.input} ${styles.disable}`}
                                  style={{ width: "40%" }}
                                >
                                  <label>Esse será o troco</label>
                                  <div className={styles.money_changes}>
                                    <span>
                                      R${" "}
                                      {parseFloat(paymentMoney) > 0
                                        ? (
                                            parseFloat(paymentMoney) - total
                                          ).toFixed(2)
                                        : parseFloat(
                                            (0 * -1).toString(),
                                          ).toFixed(2)}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            )}
                          </>
                        )}

                        {paymentsAfterAble.ableOthers &&
                          othersPayments.length > 0 && (
                            <>
                              <div className={styles.payment_card_option}>
                                <span className="font-bold text-text-dark">
                                  Outros
                                </span>
                              </div>
                              {othersPayments.map((payment) => (
                                <div
                                  className={
                                    payment.id === selectedPaymentAfter?.id
                                      ? styles.type_method_selected
                                      : styles.type_method
                                  }
                                  onClick={() => {
                                    changePayment(
                                      "delivery-payment",
                                      payment.pluginconfigId,
                                    );
                                    setTypeAfter("others");

                                    setSelectedPaymentAfter(payment);
                                  }}
                                >
                                  {cardIcon("others".toLowerCase())}
                                  <p>{payment.brand}</p>
                                  {ninegridMotorAble &&
                                    payment.ableDiscount && (
                                      <CardPaymentDiscount
                                        discountType={
                                          payment.typeDiscount ?? "percentage"
                                        }
                                        discountValue={payment.discountValue}
                                      />
                                    )}
                                </div>
                              ))}
                            </>
                          )}
                      </div>
                    )}

                    <ButtonCheckout
                      action={async () => {
                        if (
                          typePayment === "delivery-payment" &&
                          (typeAfter === "card" || typeAfter === "others")
                        ) {
                          await syncSelectedPaymentDiscount();
                          setOpenModalInstallment(true);
                          return;
                        }
                        await choosePayment();
                      }}
                      label={
                        isApplyingPaymentDiscount
                          ? "Calculando desconto..."
                          : "Continuar"
                      }
                      backgroundColor={
                        config?.webappcolor.webappbutton
                          ? config.webappcolor.webappbutton
                          : "#EAEAEA"
                      }
                      color={
                        config?.webappcolor.fontbutton
                          ? config?.webappcolor.fontbutton
                          : "#636363"
                      }
                      disabled={isApplyingPaymentDiscount}
                      marginBottom
                    />
                  </>
                )}
              </div>
            </div>
          </div>
        )}

        <Menu
          activeMenu="cart"
          fontColor={
            config?.webappcolor.iconsfooter
              ? config?.webappcolor.iconsfooter
              : "#636363"
          }
          activeFontColor={
            config?.webappcolor.highlightfooter
              ? config?.webappcolor.highlightfooter
              : "#000"
          }
          backgroundMenu={
            config?.webappcolor.backgroundfooter
              ? config?.webappcolor.backgroundfooter
              : "#F5F5F5"
          }
          colorIcons={
            config?.webappcolor.iconsfooter
              ? config?.webappcolor.iconsfooter
              : "#636363"
          }
          highlightColorIcons={
            config?.webappcolor.highlightfooter
              ? config?.webappcolor.highlightfooter
              : "#636363"
          }
          backgroundCart={
            config?.webappcolor.backgroundcart
              ? config.webappcolor.backgroundcart
              : "#FFBA49"
          }
          fontCart={
            config?.webappcolor.fontcart ? config.webappcolor.fontcart : "#000"
          }
          noSales={
            config &&
            config?.content &&
            config?.content.pdv &&
            config?.content.pdv.noSales
              ? config.content.pdv.noSales
              : false
          }
        />
      </div>
      {openModalInstallment && (
        <ModalSelectInstallment
          open={openModalInstallment}
          onClose={() => setOpenModalInstallment(false)}
          payments={paymentsAfter}
          paymentSelected={selectedPaymentAfter}
          /*Por conta dos descontos colocar aqui */
          total={installmentPreviewTotal ?? total}
          config={config}
          setInstallment={setInstallments}
          setCodePlanSelected={setCodePlanSelected}
          onNext={choosePayment}
        />
      )}
    </div>
  );
};

export { NewChoosePayment };
